<template>
    <div id="cloud" class="cloud" >
        <section id="cloud-entry-wrap" class="cloud-entry-wrap">
            <div class="cloud-entry">
                <div class="container">
                    <div class="cloud-logo"><img src="~IMAGE/homepage/cloud-logo.png" alt=""></div>
                    <h1 class="title">{{ $t( 'homepage.entryTitle' ) }}</h1>
                    <p class="subtitle">{{ $t( 'homepage.entrySubTitle' ) }}</p>
                    <div
                    v-show="isLogin !== null"
                    :class="['entry-box', 'area-choose-des', isLogin ? 'is-login' : 'no-login']">
                        <div>
                            <a :href="loginDashboardUrl" class="ui-button primary-button" v-show="!isLogin">{{ $t( 'homepage.btnLogin' ) }}</a>
                            <router-link
                            :to="{path: '/user/cloud-library/'}"
                            class="ui-button primary-button"
                            ga-label="My Cloud Library"
                            v-show="isLogin">
                                {{ $t( 'homepage.cloud_library' ) }}
                            </router-link>
                        </div>
                        <div>
                            <a :href="signupUrl" class="dredge ui-button primary-button">{{ $t( 'homepage.btnDredge' ) }}</a>
                        </div>
                    </div>
                    <div class="jump-to" @click="jumpToPlan">
                        <p>{{ $t('homepage.seePlan') }}</p>
                        <span class="icon-icon_arrow-down"></span>
                    </div>
                </div>
            </div>
        </section>

        <section id="video-record-wrap" class="video-record-wrap">
            <div id="video-record" class="video-record">
                <div class="container">
                    <div class="phone pc-phone">
                    </div>
                    <div class="notice">
                        <h5 class="subtitle pc-title">{{ $t( 'homepage.videoRecordSubTtitle' ) }}</h5>
                        <h3 class="title pc-title">{{ $t( 'homepage.videoRecordTtitlePC' ) }}</h3>
                        <h3 class="m-title">{{ $t( 'homepage.videoRecordTtitle' ) }}</h3>
                        <p class="des">{{ $t( 'homepage.videoRecordDes' ) }}</p>
                    </div>
                    <div class="phone m-phone">
                    </div>
                </div>
            </div>
        </section>

        <section id="cloud-introducing-wrap" class="video-record-wrap cloud-introducing-wrap">
            <div id="cloud-introducing" class="video-record cloud-introducing">
                <div class="container">
                    <div class="notice">
                        <h5 class="subtitle pc-title">{{ $t( 'homepage.introducing_Subtitle' ) }}</h5>
                        <h3 class="title pc-title">{{ $t( 'homepage.introducing_title' ) }}</h3>
                        <h3 class="m-title">{{ $t( 'homepage.introducing_title' ) }}</h3>
                        <p class="des">{{ $t( 'homepage.introducing_des' ) }}</p>
                    </div>
                    <div class="phone pc-phone">
                    </div>
                    <div class="phone m-phone">
                    </div>
                </div>
            </div>
        </section>

        <section id="supported-country-and-device" class="supported-country-and-device">
            <h3 class="title">{{ $t( 'homepage.compatibility.title' ) }}</h3>
            <div class="content">
                <div v-if="!FEATURE('homepage.supported_countries')">
                    <h5>{{ $t( 'homepage.compatibility.countryTitle' ) }}</h5>
                    <item-list
                    :search-mode="true"
                    :list="supportedCountryList"></item-list>
                </div>
                <div>
                    <h5>{{ $t( 'homepage.compatibility.deviceTitle' ) }}</h5>
                    <item-list
                    :link-mode="true"
                    :list="supportedDeviceList"></item-list>
                </div>
            </div>
            <p v-if="!FEATURE('homepage.compatibility_notice')">{{ $t( 'homepage.compatibility.notice' ) }}</p>
            <button
            v-if="!FEATURE('homepage.compatibility_notify')"
            @click="showSubscription = true"
            class="ui-button primary-button short-button"
            ga-label="Stay Tuned for Cloud Updates">{{ $t( 'homepage.compatibility.notify' ) }}</button>
            <reo-dialog
            @cancel="showSubscription = false"
            v-show="showSubscription">
                <email-subscription subject="cloud-update"></email-subscription>
            </reo-dialog>
        </section>

        <section class="unique-plan" id="unique-plan" v-if="!isMobile && basicIndex !== -1">
            <uniquePlanItem :plan="basicSerial" v-if="basicSerial.serialName"></uniquePlanItem>
        </section>

        <section class="plans-select" id="plans-select">
            <div>
                <h3 class="title showInPc" v-if="planList.length">{{ $t( 'homepage.plan_title' ) }}</h3>
                <h3 class="title showInMobile" v-if="planList.length">{{ $t( 'homepage.plan_title_m' ) }}</h3>
                <p
                class="notice-for-free"
                v-html="planNoticeText"
                v-if="planList.length && cloudConfig.planNotice && cloudConfig.planNotice.show">
                </p>
                <div class="plan-content pc" v-if="planList.length">
                    <carousel
                    ref="planCarousel"
                    :mouseDrag="false"
                    :items="carouselItems">
                        <plan-item-col v-for="(plan, index) in planList"
                        :key="index"
                        :plan="plan"
                        :subscription="sub"
                        :activeItem="activeItem"
                        :listIndex="index"
                        @changeActive="changeActive"></plan-item-col>
                    </carousel>
                    <button
                    class="ui-button primary-button short-button subscription-button"
                    @click="goSubscription"
                    v-if="userStatus === 'logined' || userStatus === 'notLogined'"
                    ga-label="Subscribe to Reolink Cloud">
                        {{ $t('homepage.subscribe_plan_button') }}
                    </button>
                </div>
                <div class="plan-content mobile" v-if="planList.length">
                    <plan-item-col v-for="(plan, index) in planList"
                    :key="index"
                    :plan="plan"
                    :subscription="sub"
                    :activeItem="activeItem"
                    :listIndex="index"
                    @changeActive="changeActive"></plan-item-col>
                    <div
                    class="subscription-button-mobile"
                    @click="goSubscription"
                    v-if="mobileSubBtnShow && (userStatus === 'logined' || userStatus === 'notLogined')"
                    ga-label="Subscribe to Reolink Cloud">
                        {{ $t('homepage.subscribe_plan_button') }}
                    </div>
                </div>
                <div class="plan-bottom">
                    <div class="des">
                        <p>
                            <i class="icon-icon_money-back"></i>
                            <span>{{ $t('homepage.money_back_1') }}</span>
                        </p>
                        <p>
                            <i class="icon-icon2_security"></i>
                            <span>{{ $t('homepage.money_back_2') }}</span>
                        </p>
                    </div>
                    <p class="payment">
                        <span>{{ $t('homepage.money_back_3') }}</span>
                        <template v-if="FEATURE('cloud.paypal')">
                            <img class="cn-payment" v-for="(item, index) in paymentMethods.cn" :key="index" :src="item" alt="">
                        </template>
                        <img v-else v-for="(item, index) in paymentMethods.all" :key="index" :src="`https://cdn.reolink.com/wp-content/uploads/2016/10/${item}.png`" alt="">
                    </p>
                </div>
            </div>
        </section>

        <section id="faqs-wap" class="faqs-wrap">

            <div id="faqs" class="faqs">

                <div class="container">
                    <h3 class="title">{{ $t( 'homepage.faqsTitle' ) }}</h3>
                    <div class="item" v-for="(item, index) in $t( 'homepage.faqsQues' )" :key="index">
                        <a href="javascript:void(0);" :id="index" class="hash-target"></a>
                        <h5 class="ques">• {{ item.ques }}</h5>
                        <p class="des" v-for="(n, i) in item.des" :key="i" v-html="$t(`homepage.faqsQues.${index}.des.${i}`, {
                            device,
                            country: countrySupported
                        })"></p>
                    </div>
                    <a v-if="!FEATURE('homepage.explore_more')" :href="config.support_cloud_url" target="_blank" class="ui-link cloud-support">
                        <span class="text">{{ $t('homepage.cloud_support') }}</span>
                        <span class="ui-icon icon-icon_arrow-right"></span>
                    </a>
                </div>

            </div>

        </section>
    </div>

</template>

<script>
import { config } from 'CONFIG';
import { isInVisibleArea, isMobile } from '@/common/js/utils';
import { getSupportedCountries } from '@/api/cloud';
import { mapGetters } from 'vuex';
import ReoInput from '@/basic/Input';
import { getCloudConfig, listToString } from '@/api/s3Config';
import { unfoldError } from '@/common/js/notice';
import { getProducts } from '@/api/cart';
import planItemCol from '@/components/planItemCol';
import uniquePlanItem from '@/components/uniquePlanItem';
import paymentMethods from '@/config/paymentMethods';
import { orderedProductInfo } from '@/api/plan';
import Carousel from '@/basic/Carousel';
import router from '@/router';
import user from '@/api/user';
import store from '@/store';
import itemList from '@/basic/itemList';
import emailSubscription from '@/components/emailSubscription';
import reoDialog from '@/basic/Dialog';

export default {

    components: {

        ReoInput,
        planItemCol,
        Carousel,
        itemList,
        emailSubscription,
        reoDialog,
        uniquePlanItem

    },

    data () {

        return {

            items: [
                {text: 'C2 Pro/C1 Pro', value: 'C2 Pro/C1 Pro'},
                {text: 'E1/E1 Pro', value: 'E1/E1 Pro'},
                {text: 'RLC-410/410W', value: 'RLC-410/410W'},
                {text: '511/511W', value: '511/511W'},
                {text: 'RLC-420/422/422W', value: 'RLC-420/422/422W'},
                {text: 'RLC-423', value: 'RLC-423'},
                {text: 'B800', value: 'B800'},
                {text: 'RLK16-410B8/RLK8-410B4/RLK8-410B2D2/RLK8-420D4/RLK4-410B4', value: 'RLK16-410B8/RLK8-410B4/RLK8-410B2D2/RLK8-420D4/RLK4-410B4'},
                {text: 'RLK8-800B4', value: 'RLK8-800B4'},
                {text: 'RLK4-211WB4-S', value: 'RLK4-211WB4-S'}
            ],
            deviceList: [],
            planList: [],
            paymentMethods,
            config,
            sub: null,
            discount: 0,
            activeItem: 100,
            carouselItems: 4,
            scrollHandleEnable: true,
            mobileSubBtnShow: false,
            cloudConfig: {},
            supportedCountryList: [],
            showSubscription: false,
            basicSerial: {},
            basicIndex: -1

        };

    },

    async created () {

        this.getPlans();
        [ this.cloudConfig, this.supportedCountryList ] = await Promise.all( [
            getCloudConfig(),
            getSupportedCountries()
        ] );

    },

    methods: {

        getProductLink ( link, langFlag ) {

            let index = link.indexOf( '/product' );

            if ( index === -1 ) {

                return link;

            }

            return link.substring( 0, index ) + langFlag + link.substr( index );

        },
        async getPlans () {

            try {

                let planList = await getProducts();
                this.basicIndex = planList.findIndex( plans => {

                    return plans.serialName === config.basic_plan_title;

                });
                if ( this.basicIndex !== -1 ) {

                    this.basicSerial = planList.splice( this.basicIndex, 1 )[0];
                
                }

                if ( this.isMobile && this.basicSerial.serialName ) {

                    planList.unshift( this.basicSerial );

                }
                this.planList = planList;
                if ( planList.length < 4 ) {

                    this.carouselItems = planList.length;

                }
                if ( planList.length ) {

                    this.$nextTick(() => {
    
                        this.$refs.planCarousel.init();
    
                    });
                
                }

            } catch ( err ) {

                console.error( err );
                unfoldError( 'errors.server_error' );

            }

        },

        changeActive ( index ) {

            this.activeItem = index;

        },

        async goSubscription () {

            if ( this.userStatus === 'logined' ) {
                
                try {

                    let sub = await orderedProductInfo();
                    let path = sub ? '/user/update-plan/' : '/user/subscribe-plan/';
                    router.push({ path });

                } catch ( err ) {

                    console.log( err );

                }

            } else {

                user.goToAccountCenter( true );

            }

        },

        scrollHandle ( e ) {

            if ( !this.scrollHandleEnable ) {

                return false;

            }
            this.scrollHandleEnable = false;
            setTimeout(() => {

                if ( $( 'body' ).eq( 0 )[ 0 ].offsetWidth < 1200 ) {

                    this.calcPlanIsInWindow( e );

                }
                this.scrollHandleEnable = true;

            }, 100 );

        },

        calcPlanIsInWindow ( e ) {

            let visible = isInVisibleArea( '#plans-select' );
            this.mobileSubBtnShow = visible;

        },

        jumpToPlan () {

            window.scrollTo( 0, $( '#supported-country-and-device' ).offset().top - $( '#header' ).height());

        }

    },

    async mounted () {

        // let cloudConfig = await getCloudConfig();
        // this.discount = cloudConfig.discount ? parseInt( cloudConfig.discount * 100 ) : 0;
        window.addEventListener( 'scroll', this.scrollHandle );

    },

    computed: {

        currentLang () {

            return this.$store.state.lang.lang;

        },

        isMobile () {

            return isMobile();

        },

        supportedDeviceList () {

            let langFlag = this.currentLang === 'en' ? '' : '/' + this.currentLang;

            let deviceList = this.cloudConfig.productSupported;

            if ( !deviceList || !deviceList.length ) {

                return [];

            }

            return this.cloudConfig.productSupported.map(
                item => ({

                    text: item.product,
                    image: item.img,
                    link: this.getProductLink( item.link, langFlag )

                })
            );

        },
        loginDashboardUrl () {

            return config.accountCenterLoginUrl + '?redirect=' + window.location.origin + '/user/cloud-library/';

        },

        signupUrl () {

            return config.accountCenterSignupUrl + '?redirect=' + window.location.origin + '/user/cloud-library/';

        },

        isLogin () {

            return this.userId;

        },

        ...mapGetters( [

            'cloudHost',
            'userId'

        ] ),

        lang () {

            return this.$store.state.lang.lang;

        },

        device () {

            let deviceList = this.cloudConfig.productSupported;
            if ( !deviceList || !deviceList.length ) {

                return '';

            }
            return listToString( deviceList.map( item => item.product ));

        },

        countrySupported () {

            let countrySupported = this.cloudConfig.countriesSupported;
            if ( !countrySupported || !countrySupported.length ) return '';
            let locale = this.lang;
            let texts = countrySupported.map( item => item[ locale ] );
            if ( !texts || !texts.length ) {

                return '';

            }
            return listToString( texts );

        },
        userStatus () {

            return this.$store.state.user.status;

        },
        planNoticeText () {

            if ( !this.cloudConfig.planNotice || !this.cloudConfig.planNotice.show || !this.cloudConfig.planNotice.text ) {

                return '';

            } else {

                let lang = store.state.lang.lang;
                return this.cloudConfig.planNotice.text[lang] || '';

            }

        }

    },

    destroyed () {

        window.removeEventListener( 'scroll', this.scrollHandle );

    }

};

</script>

<style rel="stylesheet/css" lang="less">

.cloud .faqs .des{
    a{
        color: @theme;
        &:hover{
            text-decoration: underline;
        }
    }
}
.available-area{
    span{
        color: #D94429;
    }
}
#cloud .plan-content .plan-item-col{
    box-sizing: border-box;
    width: 285px;
    @media @mobile{
        &, &.recommend{
            width: 100%;
        }
    }
}
.plans-select .notice-for-free{
    margin: 0.2rem auto 0.4rem;
    .des{
        margin-top: 0.08rem;
        display: block;
    }
    @media @mobile{
        padding: 0 15px;
        margin-top: 0.3rem;
        &+.plan-content.pc+.plan-content.mobile{
            margin-top: 0.3rem;
        }
    }
}
</style>

<style scoped rel="stylesheet/css" lang="less">

:target:before,
.hash-target{
    display: block;
    height: 1.5rem;
    margin: -1.5rem 0 0;
    cursor: auto;
}

.cloud {
    color: #333;
    text-align: center;
    font-weight: 400;
    line-height: 1.2;
}

.cloud select {
    /*统一边框*/
    border: none;
    /*将默认的select选择框样式清除*/
    /* appearance:none; */
    -moz-appearance:none;
    -webkit-appearance:none;
    background: url(~IMAGE/homepage/new-select-bg-1.png) #f5f5f5 no-repeat;
    border-radius: 100px;
    font-size: 16px;
    letter-spacing: 0.7px;
    width: auto;
    box-shadow: none;
    font-weight: 500;
    box-sizing: border-box;
    max-width: 100%;
    vertical-align: middle;
    color: #333;
}

/*清除ie的默认选择框样式清除，隐藏下拉箭头*/
.cloud select::-ms-expand { display: none; }

.cloud section > div {
    padding: 0 15px;
}

.mobile-limit-note{
    margin: -0.42rem 15px 0.64rem;
    font-size: 0.26rem;
}

.limit-note{
    margin: 40px auto -20px;
    font-size: 16px;
}

.cloud .hide {
    display: none;
}

.cloud input {
    border: 1px solid transparent;
}

.cloud input::-webkit-input-placeholder,
.cloud input::-moz-placeholder {
    color: #ccc;
}

.cloud li,
.cloud img,
.cloud label,
.cloud input {
    vertical-align: middle;
}

.cloud .cloud-button {
    display: inline-block;
    padding: 0 24px;
    color: #fff;
    border-radius: 30px;
    height: 48px;
    line-height: 46px;
    font-weight: 500;
    font-size: 16px;
    border: 1px solid transparent;
    cursor: pointer;
}

@media screen and (min-width: 1200px) {
  .cloud .cloud-button:hover {
    border: 1px solid #1dc4e4;
    color: #1dc4e4;
    background: none;
  }
}

.cloud .cloud-button:active {
    border: 1px solid #1dc4e4;
    color: #1dc4e4;
    background: none;
}

.cloud .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0;
    position: relative;
}

/* entry --B */

.cloud .cloud-entry {
    padding: 0.58rem 15px 0.46rem;
    background: url(~IMAGE/homepage/subscribe-email-bg.jpg) #f3f4f9 top
        center no-repeat;
}

.jump-to {
    color: #00ade5;
    cursor: pointer;
    margin-top: 0.4rem;
    display: inline-block;
    font-size: 0.18rem;
    &>p{
        font-weight: 500;
        margin-bottom: 0.16rem;
    }
    @media @mobile {
        font-size: 0.26rem;
    }
}

.entry-box a{
    box-sizing: border-box;
    width: 1.5rem;
    line-height: 0.48rem;
    display: none;
}

.entry-box.is-login a{
    width: 3.6rem;
    display: inline-block;
}

.entry-box.no-login a{
    display: inline-block;
}

.entry-box.is-login>div p{
    display: none;
}

.cloud .cloud-entry .cloud-logo {
    margin-bottom: 0.2rem;
}

.cloud .cloud-entry .cloud-logo img {
    height: 50px;
}

.cloud .cloud-entry .title {
    font-size: 60px;
    font-weight: 700;
    margin-bottom: 0.2rem;
}

.cloud .cloud-entry .subtitle,
.cloud .cloud-entry .date {
    font-size: 0.24rem;
}

.cloud .cloud-entry .entry-box div {
    display: inline-block;
    margin: 0 0.1rem;
}

.cloud .cloud-entry .entry-box.is-login div+div{
    display: none;
}

.email-subscribe .reo-input-wrap{
    width: 3.6rem;
    margin-right: 0.2rem;
}

@media screen and (max-width: 1199px) {
    .cloud .cloud-entry .entry-box div {
        display: block;
        width: 6.93rem;
        margin: 0 auto;
    }

    .cloud .cloud-entry .entry-box div+div{
        margin: 0.2rem auto 0;
    }

    .cloud .cloud-entry .entry-box .ui-button{
        line-height: 0.78rem;
        display: block;
        border-radius: 0.45rem;
        margin: 0;
        width: 100%;
    }
    .email-subscribe .reo-input-wrap{
        margin-top: 0.3rem;
        width: 100%;
    }
}

.cloud .cloud-entry .entry-box .cloud-button {
    min-width: 137px;
    box-sizing: border-box;
}

.email-subscribe p.verify-suc{
    color: #63C622;
    font-size: 0.22rem;
    font-weight: 500;
    text-align: center;
    position: relative;
    display: inline-block;
    padding-left: 0.4rem;
    text-align: left;
    max-width: 7rem;
}

.email-subscribe p.verify-suc .icon-icon_have{
    font-size: 0.3rem;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
}

@media screen and (max-width: 1199px) {
    .cloud .cloud-button,
    .cloud .m-button {
        display: block;
        width: 6.93rem;
        height: 0.78rem;
        line-height: 0.78rem;
        padding: 0 15px;
        margin: 0 auto;
        font-size: 0.28rem;
        border-radius: 100px;
        text-align: center;
        box-sizing: border-box;
    }

    .cloud .cloud-entry {
        padding: 0.5rem 15px 0.47rem;
        background: url(~IMAGE/homepage/subscribe-email-bg-m.jpg) #f3f4f9
        top center no-repeat;
        background-size: 100% auto;
    }

    .cloud .cloud-entry .cloud-logo {
        display: block;
    }

    .cloud .cloud-entry .cloud-logo img {
        display: block;
        margin: 0 auto;
        max-width: 80px;
        width: 0.8rem;
        height: auto;
    }

    .cloud .cloud-entry .title {
        margin-top: 0.28rem;
        font-size: 0.64rem;
    }

    .cloud .cloud-entry .subtitle,
    .cloud .cloud-entry .date {
        margin-top: 0.22rem;
        font-size: 0.32rem;
    }

    .cloud .cloud-entry .entry-box {
        margin-top: 0.56rem;
    }

    .email-subscribe p.verify-suc{
        font-size: 0.26rem;
        max-width: 100%;
        margin: 0 0.3rem;
        padding-left: 0.6rem;
    }

    .email-subscribe p.verify-suc .icon-icon_have{
        font-size: 0.5rem;
    }

}

/* entry --E */

/* video-record --B */

.cloud .video-record {
  padding: 80px 15px;
  background-color: #f3f4f9;
}

.cloud .video-record .container {
  max-width: 940px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#cloud-introducing{
    background-color: #fff;
    @media @pc{
        padding: 1.8rem 15px;
    }
}

#cloud-introducing .container{
    max-width: 1200px;
}

.cloud .video-record .pc-phone {
  display: block;
  width: 340px;
  height: 616px;
  background: url(~IMAGE/homepage/video-record-bg.png) center center no-repeat;
}

.cloud .video-record.cloud-introducing .pc-phone{
    background: url(~IMAGE/homepage/homepage-introducing.png) center center no-repeat;
    background-size: 100%;
    height: 350px;
    width: 500px;
}

.cloud .video-record .m-phone {
  display: none;
}

#cloud-introducing .notice{
    padding: 0;
}

.cloud .video-record .notice {
  text-align: left;
  max-width: 574px;
  padding-left: 40px;
}

.cloud .video-record .subtitle {
  font-size: 24px;
  font-weight: 500;
}

.cloud .video-record .title {
  font-size: 46px;
  font-weight: 500;
  margin-top: 30px;
}

.cloud .video-record .des {
  font-size: 18px;
  margin-top: 38px;
}

.cloud .video-record .pc-title {
  display: block;
}

.cloud .video-record .m-title {
  display: none;
}

@media screen and (max-width: 1199px) {
  .cloud .video-record .pc-title {
    display: none;
  }

  .cloud .video-record .m-title {
    display: block;
  }

  .cloud .video-record {
    padding: 1.36rem 15px 0;
    background-size: 100% auto;
  }

  .cloud .video-record .container {
    display: block;
  }

  .cloud .video-record .pc-title {
    display: none;
  }

  .cloud .video-record .m-title {
    display: block;
    font-weight: 500;
    font-size: 0.52rem;
  }

  .cloud .video-record .m-phone {
    display: block;
    height: 7rem;
    width: 100%;
    background: url(~IMAGE/homepage/video-record-bg-m.png) center
      center no-repeat;
    margin-top: 0.8rem;
    background-size: auto 100%;
  }

    .cloud .video-record.cloud-introducing .m-phone{
        background: url(~IMAGE/homepage/homepage-introducing.png) top center no-repeat;
        background-size: 500px;
        height: 3.5rem;
    }

  .cloud .video-record .pc-phone {
    display: none;
    background: none;
  }

  .cloud .video-record .notice {
    max-width: 100%;
    padding: 0;
  }

  .cloud .video-record .des {
    font-size: 0.32rem;
    margin-top: 0.56rem;
  }
}

@media screen and (max-width: 800px) {

    .cloud .video-record .m-phone {
        height: 9rem;
    }
    .cloud .video-record.cloud-introducing .m-phone {
        background-size: 100%;
        height: 5rem;
    }

}

/* video-record --E */

/*  updated-banner --B */

.cloud .updated-banner {
  padding: 100px 15px;
  background: url(~IMAGE/homepage/updated-banner-bg.jpg) center
    center no-repeat;
}

.cloud .updated-banner .title {
  font-size: 32px;
  font-weight: 500;
}

.cloud .updated-banner .des {
  font-size: 18px;
  margin-top: 20px;
}

@media screen and (max-width: 1199px) {
  .cloud .updated-banner {
    padding: 1.1rem 15px;
    background: url(~IMAGE/homepage/updated-banner-bg-m.jpg) center
      center no-repeat;
    background-size: 100% auto;
  }

  .cloud .updated-banner .title {
    font-size: 0.52rem;
  }

  .cloud .updated-banner .des {
    font-size: 0.32rem;
    margin-top: 0.26rem;
  }
}

@media screen and (max-width: 800px) {

  .cloud .updated-banner {
    background-size: 100% 100%;
  }

}

/*  updated-banner --E */

/* product-subscribe --B */

.cloud .product-subscribe {
  padding: 62px 15px;
  background: url(~IMAGE/homepage/product-subscribe-bg.jpg) center
    center no-repeat;
}

.cloud .product-subscribe .title {
  color: #fff;
  font-size: 36px;
  font-weight: 500;
  max-width: 710px;
  margin: 0 auto;
}

.cloud .product-subscribe .row-entry {
  margin-top: 40px;
}

.cloud .product-subscribe .select-wrap {
  display: inline-block;
  margin-right: 10px;
  font-size: 18px;
  position: relative;
  vertical-align: middle;
}

.cloud .product-subscribe .rl-select {
  height: 48px;
  padding-left: 30px;
  padding-right: 150px;
  background-position: 90% 50%;
  background-size: 37px;
}

.cloud .product-subscribe .rl-select option:first-of-type {
  background-color: #c8c8c8;
}

.cloud .product-subscribe .entry-box {
    min-height: 88px;
}

.cloud .select-wrap .select-before,
.cloud .select-wrap .select-after {
  display: none;
}

.cloud .product-subscribe .submit-product {
  border: 2px solid #fff;
  line-height: 48px;
  vertical-align: middle;
}

.cloud .tips-wrap {
    height: 25px;
    margin-top: 10px;
}

.cloud .tips-wrap {
    font-size: 16px;
}

.cloud .success-tips {
    margin-top: 40px;
    font-size: 16px;
    color: #83FC35;
}

.cloud .tips {
    color: #E23423;
    font-weight: 500;
}

@media screen and (min-width: 1200px) {
  .cloud .product-subscribe .submit-product:hover {
    color: @theme;
    background: #fff;
  }
}

.cloud .product-subscribe .submit-product:active {
  color: @theme;
  background: #fff;
}

@media screen and (max-width: 1199px) {
    .cloud .product-subscribe {
        padding: 1.36rem 15px 0.67rem;
        background: url(~IMAGE/homepage/product-subscribe-bg-m.jpg)
        center center no-repeat;
        background-size: 100% auto;
    }

    .cloud .product-subscribe .title {
        font-size: 0.52rem;
        color: #fff;
        max-width: 100%;
    }

    .cloud .product-subscribe .row-entry {
        margin-top: 0.5rem;
    }

    .cloud .product-subscribe .entry-box {
        min-height: 2.44rem;
    }

    #cloud .product-subscribe .rl-select {
        padding-left: 0.46rem;
        border: none;
        background: url(~IMAGE/homepage/new-select-bg-1.png) 93% 50%
        no-repeat;
        background-size: 0.56rem;
        background-color: #f5f5f5;
        height: 0.78rem;
    }

    #cloud .product-subscribe .submit-product {
        margin-top: 0.34rem;
        line-height: 0.78rem;
    }

    .cloud .product-subscribe .select-wrap {
        margin-right: 0;
    }

    .cloud .success-tips {
        font-size: 0.28rem;
    }

    .cloud .tips-wrap {
        font-size: 0.28rem;
    }

    .cloud .tips-wrap {
        height: 0.33rem;
        margin-top: 0.2rem;
    }

}

/* product-subscribe --E */

/* faqs --B */
.cloud .faqs {
  padding: 80px 15px;
}

.cloud .faqs .title {
  font-size: 46px;
  font-weight: 700;
}

.cloud .faqs .item {
  margin-top: 22px;
  background-color: #f3f4f9;
  padding: 50px 100px 30px 65px;
  border-radius: 10px;
  text-align: left;
}

.cloud .faqs .item:first-of-type {
  margin-top: 40px;
}

.cloud .faqs .ques {
  font-size: 24px;
  font-weight: 500;
}

.cloud .faqs .des {
  font-size: 18px;
  padding-left: 1em;
  margin-top: 10px;
}

.cloud .faqs .des:first-of-type {
  margin-top: 22px;
}

@media screen and (max-width: 1199px) {
  .cloud .faqs {
    padding: 1.24rem 15px 0.26rem;
  }

  .cloud .faqs .title {
    font-size: 0.64rem;
    font-weight: 500;
  }

  .cloud .faqs .item {
    margin-top: 0.32rem;
    padding: 0.6rem 0.4rem 0.9rem 0.32rem;
  }

  .cloud .faqs .item:first-of-type {
    margin-top: 0.66rem;
  }

  .cloud .faqs .ques {
    font-size: 0.32rem;
  }

  .cloud .faqs .des {
    font-size: 0.28rem;
    padding-left: 0;
    margin-top: 0.2rem;
  }

  .cloud .faqs .des:first-of-type {
    margin-top: 0.38rem;
  }
}

/* faqs --E */

.email-subscribe p{
    font-size: 0.2rem;
    margin-bottom: 0.2rem;
}
.area-choose{
    text-align: center;
    margin: 0.6rem auto 0.3rem;
}
.area-choose-des{
    margin-top: 0.4rem;
}
.area-choose li{
    display: inline-block;
    font-size: 0.2rem;
    font-weight: 500;
    width: 50%;
    box-sizing: border-box;
    text-align: right;
    padding: 0 0.4rem;
}
.area-choose li:first-child{
    padding-left: 0;
}
.area-choose li:last-child{
    padding-right: 0;
}
.area-choose li.active{
    color: @theme;
}
@media screen and (min-width: 1200px) {
    .area-choose li span:hover{
        color: @theme;
    }
    .area-choose li span:hover:after{
        content: '';
        width: 100%;
        position: absolute;
        height: 0.02rem;
        background-color: @theme;
        bottom: -0.02rem;
        left: 0;
    }
}
.area-choose li span{
    position: relative;
    cursor: pointer;
    display: inline-block;
}
.area-choose li.active span:after{
    content: '';
    width: 100%;
    position: absolute;
    height: 0.02rem;
    background-color: @theme;
    bottom: -0.02rem;
    left: 0;
}
.area-choose li:last-child{
    text-align: left;
    border-left: 1px solid #333;
}
.available-area{
    font-size: 0.2rem;
    margin-bottom: 0.2rem;
}
.entry-box p{
    margin-top: 0.15rem;
    font-size: 0.16rem;
}
@media screen and (max-width: 1199px) {
    .email-subscribe .ui-button{
        line-height: 0.78rem;
        display: block;
        margin: 0.2rem 0 0 0;
        width: 100%;
        box-sizing: border-box;
    }
    .area-choose li{
        font-size: 0.28rem;
    }
    .entry-box p,
    .available-area,
    div.email-subscribe p{
        font-size: 0.26rem;
    }
}

.unique-plan {
    background-color: #F3F4F9;
    padding-top: 0.88rem;
}

/* plan */
.cloud section.plans-select > div{
    padding: 0;
    margin: 0 auto;
    max-width: 1200px;
}
.plans-select{
    padding: 0.6rem 0;
    background-color: #F3F4F9;
    @media @mobile{
        background-color: #fff;
        padding: 1.24rem 0 0;
    }
}
.plans-select .title{
    font-weight: 500;
    font-size: 0.46rem;
}
.plan-content{
    // display: flex;
    padding-bottom: 0.5rem;
    // justify-content: center;
    // align-items: flex-start;
    border-bottom: 1px solid #dbdbdb;
    margin-top: .8rem;
    @media @pc{
        &.mobile{
            display: none;
        }
        &.pc{
            .subscription-button{
                margin-top: 40px;
            }
        }
    }
    @media @mobile{
        &.pc{
            display: none;
        }
        display: block;
        padding: 0;
        margin-top: 0.64rem;
        .subscription-button-mobile{
            background: @theme-linear-gradient;
            height: 1rem;
            line-height: 1rem;
            color: #fff;
            font-weight: 500;
            font-size: 0.33rem;
            text-align: center;
            position: fixed;
            bottom: 0;
            z-index: 3;
            width: 100%;
        }
    }
}
.plan-discount{
    font-size: 0.2rem;
    margin-top: 0.1rem;
    @media @mobile{
        font-size: 0.26rem;
    }
}
.plan-bottom{
    display: flex;
    padding-top: 0.2rem;
    justify-content: space-between;
    align-items: center;
    @media @mobile{
        padding: 0.4rem 15px;
        text-align: left;
        display: block;
    }
    .des p{
        display: inline-block;
        font-weight: 500;
        font-size: 0;
        span{
            font-size: 0.14rem;
        }
        @media @mobile{
            span{
                font-size: 0.26rem;
            }
            margin-bottom: 0.2rem;
            display: block;
            color: #777;
            font-weight: 400;
        }
        i{
            font-size: 0.4rem;
            vertical-align: middle;
            margin-right: 0.2rem;
            color: #555;
            @media @mobile{
                display: none;
            }
        }
    }
    .des p+p{
        margin-left: 0.9rem;
        @media @mobile{
            margin-left: 0;
        }
    }
    .payment{
        font-family: roboto;
        @media @mobile{
            font-size: 0.26rem;
            img{
                max-width: 66px;
                width: 0.65rem;
            }
            img.cn-payment {
                width: auto;
                max-width: unset;
                height: .4rem;
            }
        }
        color: #777777;
        span{
            margin-right: 0.1rem;
        }
        .cn-payment {
            height: 20px;
        }
        img+img{
            margin-left: .1rem;
        }
    }
    @media @mobile{
        p:before{
            content: '';
            display: inline-block;
            width: 5px;
            height: 5px;
            background-color: #333;
            border-radius: 100%;
            margin-right: 0.1rem;
        }
    }
}
/* END plan */
.cloud-support{
    margin-top: 22px;
    display: inline-block;
    @media @mobile{
        margin-top: 0.32rem;
    }
}
.notice-for-free+.plan-content{
    margin-top: 0.4rem;
}
.supported-country-and-device {
    padding: 1rem 0 0;
    background-color: #F3F4F9;
    h3{
        margin-bottom: 0.6rem;
        font-size: 0.46rem;
        font-weight: 500;
    }
    h5{
        margin-bottom: 0.4rem;
        font-size: 0.24rem;
        font-weight: 500;
    }
    .content{
        display: flex;
        justify-content: center;
        &>div{
            padding: 0 106px;
        }
        &>div:nth-child(2){
            border-left: 1px solid #333;
        }
    }
    &>p{
        margin: 0.4rem auto 0.5rem;
        font-size: 0.18rem;
        max-width: 400px;
    }
    @media screen and (max-width: 1199px) {
        padding: 1.26rem 0 0;
        background-color: #fff;
        h3 {
            font-size: 0.64rem;
        }
        h5 {
            font-size: 0.38rem;
            margin-bottom: 0.32rem;
        }
        .content {
            display: block;
            &>div{
                padding: 0;
            }
            &>div:nth-child(2){
                margin-top: 0.8rem;
                border-left: none;
            }
            .item-list {
                margin: 0 auto;
            }
        }
        &>p{
            margin: 0.6rem auto 0.4rem;
            font-size: 0.26rem;
            max-width: 100%;
            width: 6.6rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/homepage/index.vue